var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1055 2.16667H15.8C16.735 2.16667 17.5 2.91667 17.5 3.83333V13.8333C17.5 14.75 16.735 15.5 15.8 15.5H2.2C1.265 15.5 0.5 14.75 0.5 13.8333V3.83333C0.5 2.91667 1.265 2.16667 2.2 2.16667H4.8945L5.94 1.04167C6.263 0.7 6.722 0.5 7.198 0.5H10.802C11.0372 0.500142 11.2699 0.548388 11.485 0.641655C11.7002 0.734923 11.8931 0.871161 12.0515 1.04167L13.1055 2.16667ZM4.75 8.83333C4.75 11.1333 6.654 13 9 13C11.346 13 13.25 11.1333 13.25 8.83333C13.25 6.53333 11.346 4.66667 9 4.66667C6.654 4.66667 4.75 6.53333 4.75 8.83333ZM11.5497 8.83334C11.5497 10.214 10.408 11.3333 8.99967 11.3333C7.59134 11.3333 6.44967 10.214 6.44967 8.83334C6.44967 7.45262 7.59134 6.33334 8.99967 6.33334C10.408 6.33334 11.5497 7.45262 11.5497 8.83334Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon--camera.f2816289a1dae8989d113a5cbfd6a572.svg";
export { ForwardRef as ReactComponent };